import BaseService from './BaseService'

export default class extends BaseService {
  static index(options = {}) {
    const url = super.url("sites")

    if (options.page) {
      url.searchParams.append("page", options.page)
    }

    return this.getSites().then(response => {
      return Promise.resolve({"sites": response})
    }).catch(error => {
      console.log(error)
      return Promise.reject(error.response.data)
    })
  }

  static getSites(pageNo = 1, resultList = [], extraParams = '') {
    let url = super.url("sites") + `?page[number]=${pageNo}&page[size]=${100}&${extraParams}`
    return super.get(url).then(response => {
      if (response.data.sites.length > 0) {
        resultList = resultList.concat(response.data.sites)
        return this.getSites(pageNo+1, resultList, extraParams)
      } else {
        return Promise.resolve(resultList)
      }
    }).catch(error => {
      console.log(error)
      return Promise.reject(error)
    })
  }

  static getSitesInArea({sw, ne}) {
    const extraParams = `bbox[sw]=${sw.lat},${sw.lng}&bbox[ne]=${ne.lat},${ne.lng}`;
    return this.getSites(1, [], extraParams);
  }
  
  static getSitesByName(query) {
    const url = `${super.url('sites')}?q=${query}&paginate=false`;
    return super.get(url);
  }
}
